import React, { useEffect } from "react";
import { Icon } from "../../../components/Component";

import dayjs from "dayjs";
import TransactionFlowDefaultTemplate from "../../others/transactionFlowDefaultTemplate";
import { useDispatch, useSelector } from "react-redux";
import { setHighlight } from "../../../store/slices/misc/highlightSlice";
import TopMenu from "../../../route/topMenu";
import { updateMenuData } from "../../../store/slices/misc/menuData";
import { useLocation, useParams } from "react-router";

const ExcelExportRequestedList = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { projectId: urlProjectId } = useParams();
  const { projectName, id: stateProjectId } = location.state || {};
  const projectId = urlProjectId || stateProjectId;

  const downloadHighlighted = useSelector(
    (state) => state.highlight.downloadHighlighted
  );
  useEffect(() => {
    if (downloadHighlighted) {
      // Reset the highlight state to false
      dispatch(setHighlight(false));
    }
  }, [downloadHighlighted, dispatch]);

  const columns = [
    {
      title: "ID",
      dataIndex: "reportId",
      key: "reportId",
      width: 100,
    },
    {
      title: "File Type",
      dataIndex: "fileType",
      key: "fileType",
      width: 100,
      render: (text) => <span>Excel</span>,
    },
    {
      title: "Report Name",
      dataIndex: "reportType",
      key: "reportType",
      width: 150,
    },
    {
      title: "Date & Time",
      dataIndex: "requestedDate",
      key: "requestedDate",
      width: 150,
      render: (text) => <span>{dayjs(text).format("DD-MMM-YYYY HH:mm")}</span>,
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      width: 100,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
    },
    {
      title: "File Size (KB)",
      dataIndex: "fileSize",
      key: "fileSize",
      width: 100,
    },
    {
      title: "Download Link",
      dataIndex: "filePath",
      key: "filePath",
      width: 100,
      render: (text, record) =>
        record?.status === "Processed" ? (
          <a href={text}>
            <Icon name="download" />
          </a>
        ) : null,
    },
  ];

  useEffect(() => {
    dispatch(
      updateMenuData(
        TopMenu?.projectNav?.map((item) => ({
          ...item,
          linkState: location.state,
        }))
      )
    );
  }, [location]);

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="excelexport-requested-list"
      title={projectName ? `${projectName} / Excel Export Requested` : "Excel Export Requested"}
      projectId={projectId}
      columns={columns}
      // extra={{
      //   tableScrollX: 1000,
      // }}
      extra={{
        tableScrollX: Math.min(900, window.innerWidth - 100),
      }}
    />
  );
};

export default ExcelExportRequestedList;
